import { InjectionToken } from '@angular/core';
import { IconConfig } from '@dev-fast/types';

export const SPECIAL_ICONS = new InjectionToken<IconConfig[]>('SPECIAL_ICONS');
